import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=63e98e38&scoped=true&"
import script from "./NotificationDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e98e38",
  null
  
)

export default component.exports